import React from 'react';

import { PlanProtectedArea } from 'src/components/planProtectedArea/PlanProtectedArea';

export const ProtectedGraphArea: typeof PlanProtectedArea = (props) => (
  <PlanProtectedArea {...props} redirectExpiredToOrg={true} />
);
